import { render, staticRenderFns } from "./CompanyApproval.vue?vue&type=template&id=c4f7eeb6&scoped=true&"
import script from "./CompanyApproval.vue?vue&type=script&lang=js&"
export * from "./CompanyApproval.vue?vue&type=script&lang=js&"
import style0 from "./CompanyApproval.vue?vue&type=style&index=0&id=c4f7eeb6&prod&scoped=true&lang=css&"
import style1 from "./CompanyApproval.vue?vue&type=style&index=1&id=c4f7eeb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f7eeb6",
  null
  
)

export default component.exports